import React from 'react';

import type { HiveDataSyncClient } from '@gitbook/hive-client';

/**
 * Listen to changes to the clock on a HiveDataSyncClient.
 */
export function useHiveDataSyncClock(dataSync?: HiveDataSyncClient<any>): number | undefined {
    const subscription = React.useMemo(() => {
        return {
            getCurrentValue: () => {
                if (!dataSync) {
                    return undefined;
                }

                return dataSync.clock;
            },
            subscribe: (callback) => {
                if (!dataSync) {
                    return () => {};
                }

                return dataSync.listen('update', callback);
            },
        };
    }, [dataSync]);

    return React.useSyncExternalStore(
        subscription.subscribe,
        subscription.getCurrentValue,

        // Don't handle clocks when rendering on the server.
        () => undefined
    );
}
